<template>
  <div class="information">
    <!--<van-nav-bar title="更多" left-arrow @click-left="onClickLeft" border/>-->

    <van-cell title="我的邀请人" @click="goQRCode" is-link></van-cell>
    <van-cell title="性别" :value="sexText" @click="sexShow=true" is-link></van-cell>
    <van-cell title-class="gray" title="所在地区" is-link></van-cell>
    <van-cell title="我的个签" :value="signature" @click="signatureShow=true" is-link></van-cell>
    <van-cell title-class="gray" title="我的行业" is-link></van-cell>

    <van-popup v-model="sexShow" position="bottom" class="popup-top0">
      <van-nav-bar
          title="设置性别"
          left-text="取消"
          right-text="保存"
          :left-arrow="false"
          @click-left="cancelSex"
          @click-right="saveSex"
      />
      <van-radio-group class="information-more-sex" v-model="sex">
        <van-cell-group>
          <van-cell title="男" clickable @click="sex = 1">
            <van-radio checked-color="#07c160" :name="1" />
          </van-cell>
          <van-cell title="女" clickable @click="sex = 0">
            <van-radio checked-color="#07c160" :name="0" />
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </van-popup>

    <van-popup v-model="signatureShow" position="bottom" class="popup-top0">
      <van-nav-bar
          title="设置个性签名"
          left-text="取消"
          right-text="保存"
          :left-arrow="false"
          @click-left="cancelSignature"
          @click-right="saveSignature"
      />
      <van-form
          ref="form"
          label-align="center"
      >
        <van-field
            v-model="signature"
            clearable
            type="textarea"
            rows="4"
            maxlength="100"
            show-word-limit
            placeholder="请输入个性签名"
        >
        </van-field>
      </van-form>
    </van-popup>

  </div>
</template>

<script>
import { updateUser } from '@/api/my'
export default {
  components: {
  },
  data() {
    return {
      userInfo: this.session('userInfo'),

      //性别
      sex: this.session('userInfo').sex,
      sexShow: false,

      //性别
      signature: this.session('userInfo').signature,
      signatureShow: false,

    }
  },
  computed:{
    sexText() {
      return this.sex==1?'男':this.sex==0?'女':''
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1)
    },
    goQRCode() {
      this.$router.push({ name: 'QRCode', params:{ inviteCode: this.session('user').inviteCodeOnLevel1 } })
    },

    // 性别
    cancelSex() {
      this.sex = this.session('userInfo').sex
      this.sexShow = false
    },
    saveSex() {
      updateUser({sex: this.sex, openid: this.session('userOpenId')}).then(res=>{
        if(res.code===200){
          this.$toast('修改成功！')
          this.sexShow = false
        }else {
          this.$toast(res.message)
        }
      })
    },

    // 签名
    cancelSignature() {
      this.signature = this.session('userInfo').signature
      this.signatureShow = false
    },
    saveSignature() {
      this.$refs['form'].validate().then(()=>{
        updateUser({signature: this.signature, openid: this.session('userOpenId')}).then(res=>{
          if(res.code===200){
            this.$toast('修改成功！')
            this.signatureShow = false
          }else {
            this.$toast(res.message)
          }
        })
      })
    },

  }
}
</script>

<style lang="less" scoped>
.information{

}
</style>
<style lang="less">
.information{
  .information-more-sex{

    .van-cell__value{
      display: inline-flex;
      justify-content: flex-end;
    }
  }
}
</style>